<template>
  <div class="space-y-6">
    <!-- 广告系列设置标题 -->
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-2">
        <i class="el-icon-setting"></i>
        <span class="text-base font-medium text-gray-800">广告系列设置</span>
      </div>
    </div>

    <!-- 广告系列名称 -->
    <div class="bg-purple-50 border border-purple-100 rounded-lg p-4">
      <el-form
        ref="campaignNameForm"
        :model="formData"
        :rules="rules"
        class="campaign-name-form"
        @submit.native.prevent
      >
        <el-form-item
          label="系列名称"
          prop="name"
          label-width="80px"
        >
          <el-input
            v-model="localName"
            placeholder="请输入广告系列名称"
            size="small"
            @input="handleNameChange"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 每日预算 & 投放时间 -->
    <div>
      <campaignBudget
        ref="campaignBudget"
        :currentAccount="currentAccount"
        :enumConstants="enumConstants"
        :value="localData"
        @input="handleBudgetChange"
      />
    </div>
    <!-- 启用系列跟踪模版 -->
    <el-form label-width="80px">
      <campaignTraceConfig
        :value="campaignTraceConfigData"
        @input="changeCampaignTraceConfig"
      />
    </el-form>

    <!-- 高级设置（可展开/折叠） -->
    <div class="border-t border-gray-100 pt-4">
      <div
        class="flex items-center space-x-2 cursor-pointer select-none"
        @click="advancedSettingsExpanded = !advancedSettingsExpanded"
      >
        <span class="text-sm text-gray-600">
          {{ advancedSettingsExpanded ? '∧' : '∨' }}
        </span>
        <span class="text-sm text-gray-600">
          {{ advancedSettingsExpanded ? '收起高级设置' : '展开高级设置' }}
        </span>
      </div>

      <!-- 高级设置内容 -->
      <div
        v-show="advancedSettingsExpanded"
        class="mt-4 space-y-4"
      >
        <!-- 设备定位 & 品牌规范 -->
        <div class="grid grid-cols-2 gap-6">
          <div>
            <div class="text-sm text-gray-500 mb-2">设备定位</div>
            <div class="flex items-start space-x-2">
              <i class="el-icon-monitor text-gray-400 mt-0.5"></i>
              <span class="text-sm text-gray-700"> 所有符合条件的设备 (计算机、手机、平板电脑和电视屏幕) </span>
            </div>
          </div>
          <div>
            <div class="text-sm text-gray-500 mb-2">品牌规范</div>
            <div class="text-sm text-gray-700">未设置任何规范</div>
          </div>
        </div>

        <!-- 客户获取 & IP地址排除 -->
        <div class="grid grid-cols-2 gap-6">
          <div>
            <div class="text-sm text-gray-500 mb-2">客户获取</div>
            <div class="text-sm text-gray-700">针对新客户和现有客户提供相同出价</div>
          </div>
          <div>
            <div class="text-sm text-gray-500 mb-2">IP 地址排除</div>
            <div class="text-sm text-gray-400">未设置任何排除项</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import campaignBudget from '@/views/google/create/components/campaignInfo/components/campaignBudget.vue';
import campaignTraceConfig from '@/views/google/create/components/campaignInfo/components/campaignTraceConfig.vue';
export default {
  name: 'CampaignDetail',
  components: {
    campaignBudget,
    campaignTraceConfig,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    currency: {
      type: String,
      default: 'USD',
    },
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    currentAccount: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localName: '',
      localData: {},
      advancedSettingsExpanded: false,
      campaignTraceConfigData: {},
      formData: {
        name: '',
      },
      rules: {
        name: [
          { required: true, message: '广告系列名称不能为空', trigger: ['blur', 'change'] },
          { max: 375, message: '广告系列名称长度不能超过375字符', trigger: ['blur', 'change'] },
        ],
      },
      isLocalUpdate: false, // 标志是否是本地更新
    };
  },
  watch: {
    data: {
      handler(val) {
        // 如果是本地更新触发的，跳过
        if (this.isLocalUpdate) {
          this.isLocalUpdate = false;
          return;
        }
        // 使用深拷贝确保数据独立
        this.localData = JSON.parse(JSON.stringify(val));
      },
      immediate: true,
      deep: true,
    },
    'data.name': {
      handler(val) {
        this.localName = val || '';
        this.formData.name = val || '';
      },
      immediate: true,
    },
    'data.campaignTraceConfig': {
      handler(val) {
        this.campaignTraceConfigData = val ? JSON.parse(JSON.stringify(val)) : {};
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleNameChange(value) {
      this.formData.name = value;
      this.$emit('update:name', value);
    },
    handleBudgetChange(val) {
      this.isLocalUpdate = true;
      this.localData = val;
      this.$emit('update:data', val);
    },
    changeCampaignTraceConfig(val) {
      this.campaignTraceConfigData = val;
      this.$emit('update:campaignTraceConfig', val);
    },
    // 对外提供的验证方法
    validate() {
      const promises = [];
      // 校验广告系列名称表单
      if (this.$refs.campaignNameForm) {
        promises.push(this.$refs.campaignNameForm.validate());
      }
      // 校验预算组件
      if (this.$refs.campaignBudget && this.$refs.campaignBudget.validate) {
        promises.push(this.$refs.campaignBudget.validate());
      }
      return Promise.all(promises);
    },
  },
};
</script>

<style scoped>
/* Tailwind CSS */
.campaign-name-form :deep(.el-form-item__label) {
  white-space: nowrap;
}
</style>
